import { useEffect, useState } from "react";
import { postAxiosWithToken } from "../../service/axios_service";
import { messageLogListEndPoint, groupListEndPoint, messageResendEndPoint } from "../../service/api_endpoints";
import Pagination from "../../components/Pagination";
import ResponsivePagination from 'react-responsive-pagination';
import 'react-responsive-pagination/themes/classic.css';
import Loading from "../../session/Loading";
import { useDispatch, useSelector } from "react-redux";
import { setIsLoading } from "../../redux/layout_slice";
import { setContactDataList, setContactTableFilters } from "../../redux/contacts_slice";
import toast from 'react-hot-toast';

export default function Contacts() {

    const dispatch = useDispatch();

    const { isLoading } = useSelector((state) => state.layoutSlice);
    const { contactDataList, contactTableFilters } = useSelector((state) => state.contactsSlice);

    const [responsePopUp, setResponsePopUp] = useState(false);
    const [messageResponse, setMessageRespone] = useState([]);


    const [totalPages, setTotalPages] = useState(1);

    useEffect(() => {
        getGroupsList();
    }, [contactTableFilters])

    const getGroupsList = async () => {
        dispatch(setIsLoading(true))
        let response = await postAxiosWithToken({
            url: messageLogListEndPoint,
            body: contactTableFilters
        })

        if (response != null) {
            dispatch(setContactDataList(response.data.list))
            setTotalPages(response.data.total_pages)
            dispatch(setIsLoading(false))
        }
    }


    const resendMessage = async (currentItem,index) => {
        //dispatch(setIsLoading(true))
        
        console.log(currentItem);

        let resend_response = await postAxiosWithToken({
            url: messageResendEndPoint,
            body: currentItem
        })
        if (resend_response != null && resend_response.send) {
            let items = [...messageResponse];
            let item = {...items[index]};
            item.is_send = true;
            items[index] = item;
            setMessageRespone(items);
            getGroupsList();
        }else{
            toast.error(resend_response.message)
        }

    }

    const entriesHandler = (value) => {
        dispatch(setContactTableFilters({
            items_per_page: value,
            search: contactTableFilters.search,
            page: contactTableFilters.page
        }))
    }

    return (
        <>
            <div>
                <div className='my-[10px]'>
                    <input type='text' name='search' id='search' onChange={(e) => {
                        dispatch(setContactTableFilters({
                            items_per_page: contactTableFilters.items_per_page,
                            search: e.target.value,
                            page: contactTableFilters.page
                        }))
                    }} className='text-sm bg-input-gray rounded focus:outline-primary w-full px-[15px] py-[10px]' placeholder="search" />
                </div>
            </div>
            <div className="w-full">
                <table className="w-full">
                    <thead className="bg-light-gray text-white">
                        <tr>
                            <th className="p-[10px] text-left">S No</th>
                            <th className="p-[10px] text-left">Template Name</th>
                            <th className="p-[10px] text-left">Date</th>
                            <th className="p-[10px] text-left">Success Count</th>
                            <th className="p-[10px] text-left">Failed Count</th>
                            <th className="p-[10px] text-left">View Details</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            isLoading ? <tr className=""><td colSpan={3}><div className="w-fit mx-auto py-5"><Loading /></div></td></tr> : contactDataList.map((item, index) => (
                                <tr className={`${index % 2 != 0 ? "bg-input-gray" : ""} border-b`}>
                                    <td className="p-[10px]">{index + 1}</td>
                                    <td className="p-[10px]">{item.template_name}</td>
                                    <td className="p-[10px] ">{item.trans_date}</td>
                                    <td className="p-[10px] ">{item.success_count}</td>
                                    <td className="p-[10px] ">{item.failed_count}</td>
                                    <td className="p-[10px] "><button onClick={(e) => {
                                                e.preventDefault();
                                                setMessageRespone(item.details)
                                                setResponsePopUp(true);
                                            }}>
                                                View
                                            </button></td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>

            <div className="my-[5px]">
                <div className='flex justify-between min-[500px]:flex gap-5'>
                    <div className='max-[499px]:mb-[15px] flex flex-wrap gap-3 items-center'>

                        <p>Entries</p>
                        {/* <br/> */}
                        <select value={contactTableFilters.items_per_page} onChange={(e) => entriesHandler(e.target.value)} className='border rounded-md w-[50px] font-400 text-[15px] p-[5px] outline-primary bg-white'>
                            {[10, 20, 30, 40, 50].map((limit) => (
                                <option key={limit} value={limit}>
                                    {limit}
                                </option>
                            ))}
                        </select>

                    </div>
                    <div className="w-[50%] flex justify-end gap-[5px]">
                        {/* <button onClick={(e) => { e.preventDefault(); setCurrentPage(1); }} className='cursor-pointer border text-black min-w-[35px] h-[35px] rounded flex items-center justify-center'>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <path fill="currentColor" fillRule="evenodd" d="M15.707 15.707a1 1 0 0 1-1.414 0l-5-5a1 1 0 0 1 0-1.414l5-5a1 1 0 1 1 1.414 1.414L11.414 10l4.293 4.293a1 1 0 0 1 0 1.414m-6 0a1 1 0 0 1-1.414 0l-5-5a1 1 0 0 1 0-1.414l5-5a1 1 0 0 1 1.414 1.414L5.414 10l4.293 4.293a1 1 0 0 1 0 1.414" clipRule="evenodd" />
          </svg>
        </button> */}
                        <ResponsivePagination
                            total={totalPages}
                            current={contactTableFilters.page}
                            onPageChange={page => {
                                dispatch(setContactTableFilters({
                                    items_per_page: contactTableFilters.items_per_page,
                                    search: contactTableFilters.search,
                                    page: page
                                }))
                            }}
                            className='flex gap-[5px]'
                            activeItemClassName='!text-white !bg-primary'
                            pageLinkClassName='w-full text-center'
                            pageItemClassName='cursor-pointer bg-[#F1F1F1] text-black w-[35px] h-[35px] rounded-[8px] flex items-center justify-center '
                            disabledItemClassName='border-none text-black'
                            nextClassName='text-black bg-white'
                            previousClassName='text-black bg-white'
                            previousLabel='<'
                            nextLabel='>'
                        />
                        {/* <button onClick={(e) => { e.preventDefault(); setCurrentPage(totalPages); }} className='cursor-pointer border text-black min-w-[35px] h-[35px] rounded flex items-center justify-center'>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
              <path d="M10.293 15.707a1 1 0 0 1 0-1.414L14.586 10l-4.293-4.293a1 1 0 1 1 1.414-1.414l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414 0" />
              <path d="M4.293 15.707a1 1 0 0 1 0-1.414L8.586 10L4.293 5.707a1 1 0 0 1 1.414-1.414l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414 0" />
            </g>
          </svg>
        </button> */}
                    </div>
                </div>


                {responsePopUp && <div className="w-screen h-screen bg-black fixed z-[7] top-0 left-0 bg-opacity-50 flex items-center justify-center">
                <div className="bg-white p-[30px] w-[50%] max-h-[80vh] overflow-scroll relative">
                  <p className="font-bold text-xl text-center m-[10px]">Message Sent Status</p>

                  <table className="w-full">
                    <thead className="bg-light-gray text-white">
                        <tr>
                            <th className="p-[10px] text-left">Group Name</th>
                            <th className="p-[10px] text-left">Status</th>
                            <th className="p-[10px] text-left">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            messageResponse.map((item,index) => (
                              
                               <tr className={`border-b`}>
                                    <td className="p-[10px]">{item.group_name}</td>
                                    <td className="p-[10px] ">{item.is_send ? <p className="text-green-600"> SUCCESS </p> : <p className="text-red-600">FAILED</p>}</td>
                                    <td className="p-[10px] ">

                                    { item.is_send ?'':<button className='w-fit mt-[10px] bg-primary px-[8px] py-[5px] text-white rounded' onClick={(e) => {
                                                e.preventDefault();
                                                resendMessage(item,index)
                                                //setResponsePopUp(true);
                                            }}>
                                               Re-Send
                                            </button>}
                                    </td>
                                </tr>

                            ))
                        }
                    </tbody>
                </table>

                  
                  <button className='w-full mt-[25px] bg-light-gray px-[15px] py-[10px] text-white rounded' onClick={() => {
                    setMessageRespone([]);
                    setResponsePopUp(false);
                  }}>close</button>

                </div>
              </div>}

            </div>
        </>
    );
}